// extracted by mini-css-extract-plugin
module.exports = {"stepsNav":"License_stepsNav__39_uG","navLink":"License_navLink__1rbJ8","active":"License_active__3IXZA","dragDemo":"License_dragDemo__3_T93"};